import HeaderCard from 'componentes/generic/HeaderCard';
import { useAuth } from 'context/AuthProvider';
import { ApiEndpoint } from 'helpers/ApiEndPoint';
import { httpClient } from 'helpers/HttpClient';
import QuejasList from 'pages/Operations/QuejasList';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
const URI = ApiEndpoint + 'reports/';
const ReporteQuejasPeriodo = () => {
  const Auth = useAuth();
  const [dataSmry, setDataSmry] = useState([]);
  var userData = Auth.getSessionData();

  const [dataList, setDataList] = useState([]);

  const totalQuejas =
    dataSmry.length > 0 &&
    dataSmry.reduce((acc, item) => {
      return acc + Number(item.quejas);
    }, 0);
  const changeStatus = period => {
    setDataList(null);
    let inPeriod = 0;
    console.log('period', period);
    if (period === '0-30 days') {
      inPeriod = 0;
    } else if (period === '31-45 days') {
      inPeriod = 1;
    } else if (period === '46-60 days') {
      inPeriod = 2;
    } else {
      inPeriod = 3;
    }

    httpClient(
      'POST',
      URI + 'quejasperiodext/',
      { period: inPeriod, idcustomer: 0 },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDataList(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  var icons = [
    { status: '0-30 days', icon: 'check', color: 'success' },
    { status: '31-45 days', icon: ['fas', 'archive'], color: 'info' },
    { status: '46-60 days', icon: ['fas', 'check-circle'], color: 'success' },
    {
      status: '> 60 days',
      icon: ['fas', 'check-double'],
      color: 'success-emphasis'
    }
  ];

  const getQuejasSmrList = async () => {
    setDataSmry([]);

    httpClient('POST', URI + 'quejasperiod/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setDataSmry(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getQuejasSmrList();
  }, []);

  return (
    <>
      <Card>
        <Card.Header>
          <Row className="g-0">
            <Col>
              <div
                onClick={() => {
                  changeStatus(0);
                }}
              >
                <HeaderCard
                  data={totalQuejas}
                  icon={['fas', 'clipboard-check']}
                  amountClassName="text-danger"
                  title="TOTAL DE QUEJAS"
                  helpText="Quejas Recibidas"
                  color="primary"
                ></HeaderCard>
              </div>
            </Col>
            {dataSmry &&
              dataSmry.length > 0 &&
              dataSmry.map(item => (
                <Col key={item.status}>
                  <div
                    onClick={() => {
                      changeStatus(item.periodo);
                    }}
                  >
                    <HeaderCard
                      data={item.quejas}
                      amountClassName="text-danger"
                      title={item.periodo}
                      helpText="Quejas en Proceso"
                      color={icons.find(x => x.status === item.periodo).color}
                      icon={icons.find(x => x.status === item.periodo).icon}
                    ></HeaderCard>{' '}
                  </div>
                </Col>
              ))}
          </Row>
        </Card.Header>
        <Card.Body className="px-xxl-0 pt-4">
          {dataList && (
            <>
              <QuejasList
                subTitle={
                  `Quejas Vigentes y En Proceso: ${dataList.length} Quejas` ||
                  ''
                }
                dataReport={dataList}
              ></QuejasList>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default ReporteQuejasPeriodo;
